import React, { createContext, useState, useContext } from "react";
import { i18n } from "@lingui/core";

export const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
    const [language, setLanguage] = useState(() => {
        const storedLanguage = localStorage.getItem("LANGUAGE");
        return storedLanguage || "en";
    });

    const changeLanguage = (lng) => {
        localStorage.setItem("LANGUAGE", lng);
        i18n.activate(lng); 
        setLanguage(lng);
    };

    return (
        <LanguageContext.Provider value={{ language, changeLanguage }}>
            {children}
        </LanguageContext.Provider>
    );
};

export const useLanguage = () => useContext(LanguageContext);
